export default "__VITE_ASSET__DMOgeGUn__"